import React from "react";
import { Tooltip, Text } from "@chakra-ui/react";
import { useLingui } from "@lingui/react";

interface SoftRequiredIndicatorProps {
  tooltipText?: string;
}

export const SoftRequiredIndicator: React.FC<SoftRequiredIndicatorProps> = ({
  tooltipText,
}) => {
  const { i18n } = useLingui();
  return (
    <Tooltip
      label={
        tooltipText ||
        i18n._("This field was originally unavailable during registration.")
      }
      hasArrow
      placement="top"
      data-testid="soft-required-indicator"
    >
      <Text
        as="span"
        color="green.500"
        aria-label="Soft required field"
        role="presentation"
      >
        {" "}
        *
      </Text>
    </Tooltip>
  );
};
